import React from 'react';
import { TextField } from '@mui/material';
import { useController, UseControllerProps } from 'react-hook-form';

type SelectFieldProps<T> = {
  controllerInitialState: UseControllerProps<any>;
  label: string;
  data: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
};

export const SelectField = <T extends unknown>({
  label,
  controllerInitialState,
  data,
  renderItem,
}: SelectFieldProps<T>) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController(controllerInitialState);

  return (
    <TextField
      id={controllerInitialState.name}
      select
      fullWidth
      value={value}
      onChange={onChange}
      label={label}
      error={!!error}
      helperText={error ? error.message : null}
    >
      {data.map((item, index) => renderItem(item, index))}
    </TextField>
  );
};
